import React from 'react';

class PopUpApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.property.title != undefined && this.props.property.title.length ? this.props.property.title : null,
      param1: this.props.property.param1 != undefined && this.props.property.param1.length ? this.props.property.param1 : null,
      param2: this.props.property.param2 != undefined && this.props.property.param2.length ? this.props.property.param2 : null,
      param3: this.props.property.param3 != undefined && this.props.property.param3.length ? this.props.property.param3 : null,
	  error: false,
	  deactivePop: false
    };
    this.openModal = this.openModal.bind(this);
    this.closePopUp = this.closePopUp.bind(this);
  }

  openModal() {
  }

  closePopUp(){
	this.setState({ deactivePop: !this.state.deactivePop });
  }

  render() {
    return (
      <div>
        <span className="deactivateAcc"  onClick={() => {
			this.setState({ deactivePop: !this.state.deactivePop });
		}}>Deactivate Account</span>
        {
          this.state.deactivePop &&
			<ViewDeactivePopUp property={this.props.property} closePopUp={this.closePopUp}/>
        }
      </div>
    );
  }
}

class ViewDeactivePopUp extends React.Component {
  	constructor(props) {
		super(props);
		this.state = {
		title: this.props.property.title != undefined && this.props.property.title.length ? this.props.property.title : null,
		param1: this.props.property.param1 != undefined && this.props.property.param1.length ? this.props.property.param1 : null,
		param2: this.props.property.param2 != undefined && this.props.property.param2.length ? this.props.property.param2 : null,
		param3: this.props.property.param3 != undefined && this.props.property.param3.length ? this.props.property.param3 : null,
		error: false,
		};
		this.closeModal = this.closeModal.bind(this);
		this.saveDeactive = this.saveDeactive.bind(this);
  	}

	closeModal() {
		//$(meeting_timer_alert_box).dialog('close');
		this.props.closePopUp();
	}

	saveDeactive() {
		if (typeof this.props.property.callBack === 'function') {
			this.props.property.callBack(this.state);
		}
	}

  	render() {
		const rootUser = !!this.props.property.rootUser;
		const paddLeft = rootUser ? '78%' : '44%';
		return (
			<div className="deactivePopUp" id="meeting-timer-alert-box" style={{ minheight: '175px' }}>
				<div className="wbmodal-header">
					<div className="wbmodal-htitle left">
						<b>{this.state.title}</b>
					</div>
					<div className="wbmodal-hcancel closeWsPopup right clickable" onClick={this.closeModal} style={{ marginTop: '10px' }}>
						<img className="closeX" src={`${wbConfig.baseUrl}/images/ai-v1-assets/x.png`} />
					</div>
					<div className="clear" />
				</div>

				<div className="wbmodal-contents">
					{
						(rootUser) ?  
						<div><b> &nbsp; {this.state.param3}</b> </div> 
						: 	<div><b> &nbsp; {this.state.param1}</b></div>
					}

					{
						!rootUser && 
							<div style={{ paddingBottom: '2%', paddingTop: '2%' }}>
								<span>&nbsp;{this.state.param2}</span>
							</div>
								
					}
					<div className="gbl-butn-wraper"
						style={{ width: '20%', float: 'left', paddingRight: '3%', paddingLeft: paddLeft, paddingBottom: '10px'}}>
						<div className="gbl-btn gbl-btn-cancel" onClick={this.closeModal} style={{ color: '#262626', textAlign: 'center' }}>Cancel</div>
					</div>
					{
						!rootUser && 
							<div className="gbl-butn-wraper" style={{ width: '28%', float: 'left' }}>
								<div className="gbl-btn gbl-btn-deactive" onClick={this.saveDeactive} style={{ backgroundColor: '#E5493A', textAlign: 'center' }}>Deactivate</div>
							</div>
								
					}
				</div>
			</div>
		);
  	}
}

export default PopUpApp;
